import { RG_TYPE as n } from "@project-rouge/rg-core";
import { RoundArray as t } from "../array/index4.js";
const c = [n.Facade, n.Wall, n.Corridor, n.Entrance, n.Core];
function u(r) {
  return r.type === n.Apartment ? `${r.type}|${r.name}` : `${r.type}|${f(r).join("|")}`;
}
function f(r, e = []) {
  var p;
  if (e.push(
    ...t(r.size),
    ...t(r.anchor)
  ), r.type === n.Opening && e.push(...t(r.pos)), c.includes(r.type))
    for (const i of r.children)
      f(i, e);
  return e.push(...(((p = r.data) == null ? void 0 : p.polygon) || []).flatMap((i) => t(i))), e;
}
export {
  u as hashRgObj
};
//# sourceMappingURL=index5.js.map
